import { render, staticRenderFns } from "./ModalCoin.vue?vue&type=template&id=4186e993&scoped=true&"
import script from "./ModalCoin.vue?vue&type=script&lang=js&"
export * from "./ModalCoin.vue?vue&type=script&lang=js&"
import style0 from "./ModalCoin.vue?vue&type=style&index=0&id=4186e993&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4186e993",
  null
  
)

export default component.exports